import { styled } from "@mui/system";

export const DownloadPdfButtonRoot = styled("div")` 
    button {
        color: white;
        font-size: 1rem;
        background: inherit;
        height: 2.5rem;
        width: 8.5rem;
        margin: 0.5rem;
        border: solid 2px white;
        border-radius: 5%;
    }

    button:hover {
        cursor: pointer;
        background-color: #6B00A1 ;
        transition: 500ms;
    }
`